import { BlockTime } from "./BlockPosition.js";

class Key {
    constructor(jsonStructure) {
        this.sharp_flat = jsonStructure.sharp_flat;
        this.note = jsonStructure.note;
        this.mode = jsonStructure.mode;
    }
}

export class KeyMarking {
    constructor(jsonStructure) {
        this.start_time = new BlockTime(jsonStructure.start_time);
        this.key = new Key(jsonStructure.key);
    }
}